<template>
  <el-card>
    <h1>{{ langData.block }}</h1>
    <!-- 搜索 -->
    <el-row class="search" :class="{ ar: isAr == 2 }">
      <el-col :xs="24" :lg="5">
        <el-date-picker v-model="search.start" value-format="yyyy-MM-dd" type="date" style="width: 100%"
          :placeholder="langData.selectstartDate">
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :lg="5">
        <el-date-picker v-model="search.end" value-format="yyyy-MM-dd" type="date" style="width: 100%"
          :placeholder="langData.selectendDate">
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :lg="1">
        <span>{{ langData.rid }}:</span>
      </el-col>
      <el-col :xs="24" :lg="4">
        <el-input style="width: 100%" v-model="search.rid"></el-input>
      </el-col>
      <el-col :xs="24" :lg="2">
        <el-button type="primary" @click="query(1)">{{
          langData.search
        }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="list" style="width: 100%; margin-bottom: 20px" v-loading="loading" border
        :class="{ ar: isAr == 2 }">
        <el-table-column min-width="110" prop="rid" :label="langData.id"></el-table-column>
        <el-table-column min-width="110" prop="reason" :label="langData.reason"></el-table-column>
        <el-table-column min-width="110" prop="blockedTime" :label="langData.blockedTime"
          :formatter="formatDate"></el-table-column>
        <el-table-column min-width="110" :label="langData.blockedDuration" prop="blockedDuration"
          :formatter="formatDates"></el-table-column>
      </el-table>
    </el-row>
    <el-row style="overflow: auto">
      <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="30"
        layout="prev, pager, next" :total="total" :pager-count="isMobile ? 5 : 7" :hide-on-single-page="true">
      </el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import { getBlockIncome } from '@/api/block.js'
import { block } from '@/utils/lang.js'

export default {
  data() {
    return {
      loading: false,
      dwnLoading: false,
      list: [],
      start: null,
      langData: {},
      currentPage: 1,
      total: 1,
      isMobile: window.innerWidth <= 768,
      isAr: parseInt(sessionStorage.getItem('lang')),
      agentType: [
        JSON.parse(sessionStorage.getItem('loginData')).agentType[0].value,
      ],
      search: {
        rid: null,
        start: null,
        end: null,
      },
      agentName: '',
      agentTypes: JSON.parse(sessionStorage.getItem('loginData')).agentType,
    }
  },
  created() {
    if (sessionStorage.getItem('lang')) {
      this.langData = block[parseInt(sessionStorage.getItem('lang'))]
    } else {
      window.sessionStorage.setItem('lang', '1')
      this.langData = block[1]
    }
    this.query(1)
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize)
  },
  watch: {
    '$store.state.lang': function (val) {
      this.langData = block[val]
      this.isAr = val
    },
    'isAr': function (val) {
      this.query(1)
    }
  },
  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    formatDate(row, column) {
      if (!row[column.property]) return '';

      // 获取单元格数据（假设传入的是秒级时间戳，乘以 1000 转为毫秒）
      let data = row[column.property] * 1000;
      if (data == null) {
        return null;
      }

      let dt = new Date(data);

      // 使用 UTC 方法格式化时间
      return (
        dt.getUTCFullYear() +
        '-' +
        String(dt.getUTCMonth() + 1).padStart(2, '0') +  // 补零
        '-' +
        String(dt.getUTCDate()).padStart(2, '0') +       // 补零
        ' ' +
        String(dt.getUTCHours()).padStart(2, '0') +      // 补零
        ':' +
        String(dt.getUTCMinutes()).padStart(2, '0') +    // 补零
        ':' +
        String(dt.getUTCSeconds()).padStart(2, '0')      // 补零
      );
    },
    formatDates(row, column) {
      if (!row[column.property]) return '99999h'
      const time = row[column.property]
      const hours = Math.floor(time / 3600)
      const minutes = Math.floor((time % 3600) / 60)
      const seconds = time % 60
      return `${hours}h:${minutes}m:${seconds}s`
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.query()
    },
    handleClose() {
      this.dialogVisible = false
      this.agentName = ''
      this.agentType = [this.agentTypes[0].value]
      this.agentTypes = JSON.parse(
        sessionStorage.getItem('loginData')
      ).agentType
    },
    Creates() {
      if (JSON.parse(sessionStorage.getItem('loginData')).canCreateSon == 1) {
        return true
      }
      return false
    },
    // 获取列表
    async query(page) {
      if (page) {
        this.currentPage = page
      }
      this.loading = true
      const { data: res } = await getBlockIncome({
        ...this.search,
        lang: ['en', 'zh', 'ar', 'es'][this.isAr || 0],
        page: this.currentPage,
      })
      this.loading = false
      if (res.code !== 0)
        return this.$message({
          message: res.msg,
          center: true,
          type: 'error',
        })
      this.$message({
        message: res.msg,
        center: true,
        type: 'success',
      })
      this.list = res.data.data
      this.total = res.data.total
    },

    // 获取创建
    async create() {
      let agentType = this.agentType.join()
      const { data: res } = await getAgencyregister({
        agentId: JSON.parse(sessionStorage.getItem('loginData')).agentId,
        agentType: agentType,
        agentName: this.agentName,
      })
      if (res.code !== 0)
        return this.$message({
          message: res.msg,
          center: true,
          type: 'error',
        })
      this.$message({
        message: res.msg,
        center: true,
        type: 'success',
      })

      this.handleClose()
      this.query(1)
    },
  },
}
</script>

<style lang="scss" scoped></style>